// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"3f2438cd","495":"2b42bde3"}[chunkId] + ".chunk.css";
};